import React from 'react';
import PropTypes from 'prop-types';
import MaterialTextField from './c/materialTextField/MaterialTextField';
import LeftLabelTextField from './c/leftLabeledTextField/LeftLabelTextField';
import DropDownAccumulator from './c/dropDownAccumulator/DropDownAccumulator';
import MaterialSelectField from './c/materialSelectField/MaterialSelectField';

const textFieldsComponents = {
  material: MaterialTextField,
  leftLabeled: LeftLabelTextField,
  dropDownAccumulator: DropDownAccumulator,
  materialSelectField: MaterialSelectField
};

const ConnectedTextField = ({ type, ...props }) => {
  const onChange = (event, value) => props.profilesActions.updateProfileField(value);

  const onBlur = () => props.profilesActions.blurProfileField();

  return (
    <span>
      { React.createElement(textFieldsComponents[type], { ...props, onChange, onBlur } ) }
    </span>
  );
};

ConnectedTextField.propTypes = {
  type: PropTypes.string,
  profilesActions: PropTypes.shape({
    updateProfileField: PropTypes.func,
    blurProfileField: PropTypes.func
  }).isRequired
};

ConnectedTextField.defaultProps = {
  type: 'material'
};

export default ConnectedTextField;



// WEBPACK FOOTER //
// ./src/shared/components/connectedTextField/ConnectedTextField.js